<!--
bellow is the table  -->

<div class="container-fluid pagecard employee-main" id="employee-list-page">
    <!-- <learn-more [title]="'Support Tickets' | translate | async"
        link="https://support.eatos.com/en-us/article/dashboard-employee-employees-2abmd3/"
        [content]="'Addressing issues and enhancing performance.' | translate | async"></learn-more> -->
    <div class="" style="width:auto">
        <div class="row justify-content-end">
            <div class="col-auto position-relative" style="bottom: 10px">
                <button class="new-btn" (click)="goToAddPage()">
                    + {{ "Create Ticket" | translate | async }}
                </button>
            </div>
        </div>
        <div class="row">
            <!-- Total Tickets -->
            <div class="col-12 col-md-4">
                <div class="mini-card">
                    <div class="row g-0">
                        <div class="col-8">
                            <div class="f-14 mb-1 fw-600">
                                Total Tickets
                                <i style="padding:2px" class="f-10 fas fa-info-circle vertical-align-super"
                                    [ngbPopover]=" 'Shows total number of Tickets raised to Support Team' | translate | async"
                                    triggers="mouseenter:mouseleave"
                                    [popoverTitle]="'Total Tickets' | translate | async" placement="right"></i>
                            </div>
                            <h6 class="fw-600 f-18">{{this.totalCount}}</h6>
                        </div>
                        <div class="col-4 text-end align-self-center">
                            <img src="assets/images/sale-icon.svg">
                        </div>
                    </div>
                </div>
            </div>

            <!-- Open Tickets -->
            <div class="col-12 col-md-4">
                <div class="mini-card">
                    <div class="row g-0">
                        <div class="col-8">
                            <div class="f-14 mb-1 fw-600">
                                Open Tickets
                                <i style="padding:2px" class="f-10 fas fa-info-circle vertical-align-super"
                                    [ngbPopover]=" 'A number of Tickets needing a response from Support Team' | translate | async"
                                    triggers="mouseenter:mouseleave" [popoverTitle]="'Open Tickets' | translate | async"
                                    placement="right"></i>
                            </div>
                            <h6 class="fw-600 f-18">{{this.totalOpen}}</h6>
                        </div>
                        <div class="col-4 text-end align-self-center">
                            <img src="assets/images/transactions-icon.svg">
                        </div>
                    </div>
                </div>
            </div>

            <!-- Closed Tickets -->
            <div class="col-12 col-md-4">
                <div class="mini-card">
                    <div class="row g-0">
                        <div class="col-8">
                            <div class="f-14 mb-1 fw-600">
                                Closed Tickets
                                <i style="padding:2px" class="f-10 fas fa-info-circle vertical-align-super"
                                    [ngbPopover]=" 'Total number of Tickets And queries solved.' | translate | async"
                                    triggers="mouseenter:mouseleave"
                                    [popoverTitle]="'Closed Tickets' | translate | async" placement="right"></i>
                            </div>
                            <h6 class="fw-600 f-18">{{this.totalClose}}</h6>
                        </div>
                        <div class="col-4 text-end align-self-center">
                            <img src="assets/images/sale-icon.svg">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="gross-tabs-sec border-bottom position-relative" style="z-index: 900">
        <!-- <div class="mb-3 flex-wrap">
            <div
              class="datepickerwrap form-control"
              daterangepicker
              [options]="options"
              (selected)="selectedDate($event)"
              style="max-width: 290px !important; position: relative"
              (click)="setDateTexts()"
            >
              <span
                ><span class="display-date">{{ startDateDisplayFormatted | translate | async }}</span> -
                <span class="display-date">{{ endDateDisplayFormatted | translate | async }}</span>
                </span
              >
              <img
                src="../../../../assets/fonts/bx-calendar.svg"
                class="ms-2 me-0"
                style="position: absolute; right: 0"
              />
            </div>
          </div> -->
        <!-- <nav ngbNav #nav="ngbNav" class="nav-tabs gross_tabs" [(activeId)]="active"> -->
        <!-- <ng-container [ngbNavItem]="1"> -->
        <!-- <a ngbNavLink> {{ 'Active' | translate | async }}</a> -->
        <!-- <ng-template ngbNavContent> -->
        <!-- empty list UI -->
        <div class="empty-courses" *ngIf="isEmpty">
            <div class="text-center">
                <img src="assets\images\Employees.svg" class="mb-2" />
                <h2 class="fw-600 mb-4">{{ 'Support Tickets' | translate | async }}</h2>
                <p class="f-16 mb-5"> {{ 'No Support Tickets Data Present' | translate | async }}</p>
                <!-- accessControl module="Employee" access="3" -->
                <button class="create-btn" (click)="goToAddPage()">
                    {{ 'Create Ticket(s)' | translate | async }}
                </button>
            </div>
        </div>

        <!--  table UI -->
        <div *ngIf="!isEmpty" [ngClass]="isEmpty ? 'isEmpty' : ''" class="position-relative" style="margin-top: -15px">
            <div class="table-responsive employees-table2 archive-data">
                <table id="employees-table" class="display table-make-responsive" cellspacing="0" width="100%" datatable
                    [dtOptions]="dtOptions">

                    <thead class="make-table-resp" style="border-top: 1px solid #6666;">
                        <tr>
                            <th class="text-center"> Ticket ID </th>
                            <th class="text-center"> Subject</th>
                            <th class="text-center"> Email </th>
                            <th class="text-center"> Mobile Number </th>
                            <th class="text-center"> Created At </th>
                            <th class="text-center"> Status </th>
                        </tr>
                    </thead>
                    <tbody class="fw-500">
                        <!-- <ng-container>

                    </ng-container> -->
                        <!-- (click)="openModal(content, employee)" -->
                        <tr *ngFor="let employee of employees; let i = index"
                            (click)="updateTicket(employee.merchantIssueId)" class="table-row">
                            <!--  -->
                            <td> {{ employee.issueName ? employee.issueName : 'No Ticket ID Available' | translate |
                                async}}</td>
                             <td [title]="employee?.issueTitle"> {{
                                (employee.issueTitle.length > 20
                                ? (employee.issueTitle | slice : 0 : 17) + "..."
                                : (employee.issueTitle | titlecase)) | translate | async
                                }}</td>
                            <td style="
                          font-size: 14px;
                          color: #000000;
                          width: fit-content !important;
                          overflow: hidden !important;
                          white-space: nowrap !important;
                          text-overflow: ellipsis !important;
                        ">
                                {{ employee.contactInfo.email ? employee.contactInfo.email : 'No Email Available' }}
                            </td>
                            <td style="
                      width: fit-content !important;
                      overflow: hidden !important;
                      white-space: nowrap !important;
                      text-overflow: ellipsis !important;
                    ">
                                {{ employee.contactInfo.phoneNumber ? employee.contactInfo.phoneNumber : 'No Mobile
                                Available' | translate | async}}
                            </td>

                            <td class="text-center">
                                <div>
                                    {{ _convertDate(employee.employeeId, employee.createdAt) | translate | async }}
                                </div>
                            </td>
                            <td class="text-center create-date">
                                <div class="hidden-menu">
                                    <ng-container *ngIf="employee?.issueStatus === 1; else openStatus">
                                        {{ 'Close' | translate | async }}
                                    </ng-container>
                                    <ng-template #openStatus>
                                        {{ 'Open' | translate | async }}
                                    </ng-template>
                                </div>
                                <div class="hover-menu">
                                    <button class="tooltip-custom" accessControl module="Support Tickets" access="3"
                                        (click)="updateTicket(employee._id)">
                                        <img src="/assets/images/Edit.svg" alt="edit" />
                                        <div class="cust-tool">{{ "Edit" | translate | async }}</div>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
